<script>
  export let send, receive, userId, users;
  import { flip } from "svelte/animate";

  const roles = [
    {
      role: "admin",
      name: "Adminstratorer",
      text: "Kan oprette/slette brugere og importere lagerstatus"
    },
    { role: "editor", name: "Redaktører", text: "Kan opdatere lagerstatus" },
    { role: "reader", name: "Insidere", text: "Kan se lagerstatus" },
    { role: "", name: "På bænken", text: "Personer uden adgang" }
  ];
</script>

<div class="absolute inset-0">
  {#each roles as role}
    <div class="mt-16 px-16">
      <h3 class="text-2xl font-bold text-gray-700">{role.name}</h3>
      {role.text}
      <div class="flex flex-wrap ">
        {#each Object.entries($users).filter(([id, user]) => {
          return user.role === role.role || (!role.role && !user.role);
        }) as [id, user] (id)}
          <div
            class="sm:w-1/3 w-full h-24 p-3"
            in:receive={{ key: id }}
            out:send={{ key: id }}
            animate:flip
            >
            <a
              href={'/users/' + id}
              class="text-center relative w-full flex flex-wrap justify-center
              content-center bg-white h-full shadow">
              {#if userId !== id}
                <div
                  class="absolute inset-0"
                  in:receive={{ key: 'userBox' }}
                  out:send={{ key: 'userBox' }} />
              {/if}
              <div class="relative px-4 py-1 my-2 ">
                <div>{user.emails[0].address}</div>
              </div>
            </a>
          </div>
        {/each}
      </div>
    </div>
  {/each}
</div>

<div class="fixed bottom-0 right-0 pb-4 pr-4">
  <button
    class="btn solid green lg shadow-xl"
    on:click={() => history.pushState({}, '', '/users/new')}
    in:receive={{ key: 'newUser' }}
    out:send={{ key: 'newUser' }}>
    Ny Bruger
  </button>
</div>
